import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, } from 'react';
import { useGinSteps } from '../gin-steps-provider';
import { useStepHashNavigation } from './use-step-hash-navigation';
const PaginatedGinStepsContext = createContext(undefined);
export const PaginatedGinStepsProvider = ({ children, pageIds, stepsById: stepsByIdOverride, stepIdsByPageId: stepIdsByPageIdOverride, }) => {
    const ctx = useGinSteps();
    const stepsById = stepsByIdOverride !== null && stepsByIdOverride !== void 0 ? stepsByIdOverride : ctx.stepsById;
    const stepIdsByPageId = stepIdsByPageIdOverride !== null && stepIdsByPageIdOverride !== void 0 ? stepIdsByPageIdOverride : ctx.stepIdsByPageId;
    const displayedStepsByPageId = useMemo(() => {
        return pageIds.reduce((map, pageId) => {
            const stepIds = stepIdsByPageId[pageId] || [];
            const steps = stepIds
                .map((stepId) => stepsById[stepId])
                .filter((step) => !!step);
            map[pageId] = steps;
            return map;
        }, {});
    }, [pageIds, stepIdsByPageId, stepsById]);
    const allSteps = useMemo(() => {
        const list = [];
        pageIds.forEach((pid, pIndex) => {
            const steps = displayedStepsByPageId[pid] || [];
            steps.forEach((step, sIndex) => {
                list.push({
                    step,
                    pageId: pid,
                    pageIndex: pIndex,
                    stepIndexInPage: sIndex,
                });
            });
        });
        return list;
    }, [pageIds, displayedStepsByPageId]);
    const { currentStepIndex, currentEntry, goPrev, goNext, goToStepIndex } = useStepHashNavigation({
        pageIds,
        displayedStepsByPageId,
        allSteps,
    });
    const value = useMemo(() => ({
        pageIds,
        displayedStepsByPageId,
        allSteps,
        currentStepIndex,
        currentEntry,
        goPrev,
        goNext,
        goToStepIndex,
    }), [
        pageIds,
        displayedStepsByPageId,
        allSteps,
        currentStepIndex,
        currentEntry,
        goPrev,
        goNext,
        goToStepIndex,
    ]);
    return (_jsx(PaginatedGinStepsContext.Provider, { value: value, children: children }));
};
export const usePaginatedGinSteps = () => {
    const ctx = useContext(PaginatedGinStepsContext);
    if (!ctx) {
        throw new Error('usePaginatedGinSteps must be used within a PaginatedGinStepsProvider');
    }
    return ctx;
};
